import {AppState} from 'Features/App/store';
import {DatasourceType} from 'Services/api/v2';
import {DICTIONARIES_SLICE} from '../dictionariesSlice';

export const datasourcesSelectorMonitoring = (state: AppState) => state[DICTIONARIES_SLICE].datasources;
export const datasourceSelectorMonitoring = (datasourceId: number) => (state: AppState) => {
    return state[DICTIONARIES_SLICE].datasources[datasourceId];
};

export const datasourcesByStationIdSelectorMonitoring = (stationId: number, exludeDatasourcesId?: number[]) => (state: AppState) => {
    return Object.values(state[DICTIONARIES_SLICE].datasources)
        .filter((datasource: DatasourceType) => {
            if (exludeDatasourcesId && exludeDatasourcesId.includes(datasource.datasourceTypeId)) return false;
            return datasource.stationId === stationId;
        });
};
